import { RoutePermittedRole } from '@crema/constants/AppEnums';
import React from 'react';

const IntegratedEditor = React.lazy(() => import('../../modules/IntegratedEditor'));

export const editorConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/integratedEditor',
    element: <IntegratedEditor />,
  },
];
